import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import { ChangeUserStatusType, CreateUserType, UpdateUserType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadUserImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createUser = (
  payload: CreateUserType
): Promise<AxiosResponse<CreateUserType>> => {
  return axios.post(`${baseURL}createUser`, payload);
};

export const updateUserById = (
  id: string,
  payload: UpdateUserType
): Promise<AxiosResponse<UpdateUserType>> => {
  return axios.patch(`${baseURL}updateUserById/${id}`, payload);
};

export const deleteUser = (
  userIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteUsers`, { data: userIds });
};

export const changeUserStatus = (
  id: string,
  payload: ChangeUserStatusType
): Promise<AxiosResponse<ChangeUserStatusType>> => {
  return axios.patch(`${baseURL}changeUserStatus/${id}`, payload);
};
